"use client";

import { Button, Input, cn } from "@devhop/ui";
import { MinusIcon, PlusIcon } from "lucide-react";
import { useEffect, useState } from "react";

export function WorkshopQtyStepper({
  value,
  onChange,
  min = 1,
  max = 10_000,
  disabled,
  className,
  size = "md",
}: {
  value: number;
  onChange: (qty: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  className?: string;
  size?: "sm" | "md";
}) {
  const [draft, setDraft] = useState(String(value));

  useEffect(() => {
    setDraft(String(value));
  }, [value]);

  function commit(raw: string) {
    const n = Number.parseInt(raw, 10);
    if (!Number.isFinite(n)) {
      setDraft(String(value));
      return;
    }
    const clamped = Math.min(max, Math.max(min, n));
    setDraft(String(clamped));
    if (clamped !== value) onChange(clamped);
  }

  const btnClass = size === "sm" ? "size-8" : "size-9";

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-lg border border-border bg-background",
        className,
      )}
    >
      <Button
        type="button"
        size="icon"
        variant="ghost"
        className={cn(btnClass, "rounded-r-none")}
        disabled={disabled || value <= min}
        aria-label="ຫຼຸດ"
        onClick={() => onChange(Math.max(min, value - 1))}
      >
        <MinusIcon className="size-3.5" />
      </Button>
      <Input
        inputMode="numeric"
        className={cn(
          "h-9 w-12 border-0 bg-transparent px-1 text-center text-sm tabular-nums shadow-none focus-visible:ring-0",
          size === "sm" && "h-8 w-10 text-xs",
        )}
        value={draft}
        disabled={disabled}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={() => commit(draft)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            commit(draft);
          }
        }}
      />
      <Button
        type="button"
        size="icon"
        variant="ghost"
        className={cn(btnClass, "rounded-l-none")}
        disabled={disabled || value >= max}
        aria-label="ເພີ່ມ"
        onClick={() => onChange(Math.min(max, value + 1))}
      >
        <PlusIcon className="size-3.5" />
      </Button>
    </div>
  );
}
